export interface ApiErrorPayload {
  ok: false;
  error: string;
  fieldErrors?: Record<string, string>;
}

export class ApiRequestError extends Error {
  readonly status: number;
  readonly fieldErrors?: Record<string, string>;

  constructor(message: string, status: number, fieldErrors?: Record<string, string>) {
    super(message);
    this.name = "ApiRequestError";
    this.status = status;
    this.fieldErrors = fieldErrors;
  }
}

const parseResponse = async <T>(response: Response): Promise<T> => {
  const payload = (await response.json()) as T | ApiErrorPayload;
  const maybeError = payload as Partial<ApiErrorPayload>;

  if (!response.ok || maybeError.ok === false) {
    const errorPayload = payload as ApiErrorPayload;
    throw new ApiRequestError(errorPayload.error || "Request failed.", response.status, errorPayload.fieldErrors);
  }

  return payload as T;
};

export const apiGet = async <T>(path: string): Promise<T> => {
  const response = await fetch(path, {
    credentials: "same-origin",
    headers: {
      accept: "application/json",
    },
  });

  return parseResponse<T>(response);
};

export const apiPost = async <T>(path: string, body: unknown): Promise<T> => {
  const response = await fetch(path, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "content-type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(body),
  });

  return parseResponse<T>(response);
};
